import { Button, DialogActions } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TURN_STYLES } from '@/styles/theme';

/* Resets theme MuiDialogActions purple button styles for text/cancel actions */
export const DialogActionsStyled = styled(DialogActions)({
  padding: '16px 24px',
  gap: '8px',

  '& .MuiButton-root': {
    width: 'auto',
    minWidth: '64px',
  },

  '& .MuiButton-root:not(.MuiButton-contained)': {
    backgroundColor: 'transparent',
    color: TURN_STYLES.secondaryButtonColor,
    fontWeight: 'bold',
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: 'transparent',
      color: TURN_STYLES.secondaryButtonColor,
      boxShadow: 'none',
    },

    '&.Mui-disabled': {
      backgroundColor: 'transparent',
      color: TURN_STYLES.secondaryButtonColor,
      opacity: 0.5,
    },
  },
});

export const DialogCancelButton = styled(Button)({
  fontWeight: 'bold',
  color: TURN_STYLES.secondaryButtonColor,
});

export const ConfirmOverrideButton = styled(Button)({
  backgroundColor: TURN_STYLES.primaryAccentColor,
  color: '#fff',
  fontWeight: 600,
  boxShadow: 'none',

  '&:hover': {
    backgroundColor: TURN_STYLES.violetDark,
    color: '#fff',
    boxShadow: 'none',
  },

  '&.Mui-disabled': {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.26)',
    boxShadow: 'none',
  },
});
